<template>
  <v-text-field
    v-model="selectedColor"
    hide-details
    v-bind="$attrs"
    readonly
    @click="showMenuPicker"
  >
    <template v-slot:append>
      <v-menu
        v-model="showPicker"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
        max-width="400px"
      >
        <template v-slot:activator="{ on }">
          <div :style="swatchStyle" v-on="on" />
        </template>
        <v-card class="ma-0 pa-0">
          <v-card-text class="ma-0 pa-0">
            <v-color-picker
              v-model="selectedColor"
              flat
              @input="onPickerChange"
              hide-inputs
              hide-canvas
              show-swatches
            />
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
  </v-text-field>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
        },
    },
    data: () => ({
        showPicker: false,
        selectedColor: '',
    }),
    computed: {
        swatchStyle() {
            const { showPicker } = this;
            this.selectedColor = (this.value || '#FFFFFFFF').toUpperCase();
            return {
                backgroundColor: this.selectedColor,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: '#B0BEC5',
                borderRadius: showPicker ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out',
            };
        },
    },
    methods: {
        showMenuPicker() {
            this.showPicker = !this.showPicker;
        },
        onPickerChange(color) {
            this.showPicker = false;
            this.$emit('input', color);
        },
    },
};
</script>
